// Type options for entry dropdown
export const typeOptions = [
  { key: 'text', text: 'Texto', value: 'text' },
  { key: 'video', text: 'Video', value: 'video' },
  { key: 'pdf', text: 'PDF', value: 'pdf' },
  { key: 'link', text: 'Enlace', value: 'link' },
];

// Validate URL format
export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

// Validate form inputs
export const validateEntryForm = (inputs) => {
  const errors = {};

  if (!inputs.title || inputs.title.trim() === '') {
    errors.title = 'El título es requerido';
  }

  if (!inputs.type) {
    errors.type = 'El tipo es requerido';
  }

  if (inputs.type === 'text' && !inputs.content) {
    errors.content = 'El contenido es requerido para entradas de texto';
  }

  if (['video', 'pdf', 'link'].includes(inputs.type) && !inputs.link) {
    errors.link = 'El enlace es requerido para este tipo de entrada';
  }

  if (inputs.link && !isValidUrl(inputs.link)) {
    errors.link = 'Por favor ingresa una URL válida';
  }

  return errors;
};

// Check if entry type requires link
export const requiresLink = (type) => {
  return ['video', 'pdf', 'link'].includes(type);
};

// Check if entry type requires content
export const requiresContent = (type) => {
  return type === 'text' || type === 'link' || type === 'pdf';
};

// Get link placeholder based on type
export const getLinkPlaceholder = (type) => {
  const placeholders = {
    video: 'https://www.youtube.com/watch?v=...',
    pdf: 'https://example.com/document.pdf',
    link: 'https://example.com',
  };
  return placeholders[type] || 'https://example.com';
};

// Get link label based on type
export const getLinkLabel = (type) => {
  const labels = {
    video: 'Enlace * (URL de YouTube u otro servicio de video)',
    pdf: 'Enlace * (URL del archivo PDF)',
    link: 'Enlace * (URL del enlace externo)',
  };
  return labels[type] || 'Enlace *';
};

// Get content label based on type
export const getContentLabel = (type) => {
  if (type === 'text') {
    return 'Contenido *';
  }
  return 'Contenido (Opcional - Se mostrará antes del enlace)';
};
